import { LicenseInfo } from "@mui/x-license";

const initMuiLicense = () => {
  LicenseInfo.setLicenseKey(
    "6f43feeb9dc02f1d047025face698017Tz0xMjYwNzQsRT0xODAzNTEzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=",
  );
};

export default initMuiLicense;
